import { showToast } from 'vant';


let isWeb = window.innerWidth >= 1024

export const toast =  ({message, position, duration, className, onClose}) => {
  window.onresize = () => {
    isWeb = window.innerWidth >= 1024 
  }
  showToast({
    message,
    position: isWeb ? 'top' : 'bottom',
    duration: duration || 3000,
    className: className || '',
    onClose
  })
}